import { render, staticRenderFns } from "./MpChooseAnswer.vue?vue&type=template&id=578d503c&scoped=true&"
import script from "./MpChooseAnswer.vue?vue&type=script&lang=js&"
export * from "./MpChooseAnswer.vue?vue&type=script&lang=js&"
import style0 from "./MpChooseAnswer.vue?vue&type=style&index=0&id=578d503c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578d503c",
  null
  
)

export default component.exports